module.exports = __webpack_public_path__ + "img/locking_illustration_step_1.a7defeb.png";